namespace Matrix.Data {

    @Serenity.Decorators.element("<input type='text' />")
    @Serenity.Decorators.registerEditor("Matrix.Data.ModelTargetPicker", [Serenity.IStringValue, Serenity.IReadOnly])
    export class ModelTargetPicker extends Serenity.Widget<ModelTargetPickerOptions> implements Serenity.IStringValue, Serenity.IReadOnly {

        private readOnly: boolean;
        private value: string;

        constructor(element: JQuery, opt: ModelTargetPickerOptions) {
            super(element, opt);

            this.element.attr("readonly", "readonly");

            $('<a class="inplace-button inplace-edit" style="border-radius: 0"><b><i class="mdi mdi-shape-square-plus"></i></b></a>')
                .attr("title", "Select")
                .insertAfter(this.element)
                .click(e => {
                    var dlg = new ModelTargetPickerDialog(this.options);
                    dlg.criteria = this.getFilterCriteria();
                    var val = Q.trim(this.get_value());
                    if (val.length)
                        dlg.value = val.split(',').map(x => Q.trim(x)).filter(x => !!x);
                    dlg.dialogOpen();
                    dlg.onSuccess = sel => {
                        this.set_value(dlg.value.join(', '));
                        this.element.triggerHandler("change");
                        return true;
                    }
                });

            $('<a class="inplace-button inplace-delete"><b><i class="fa fa-times"></i></b></a>')
                .attr("title", "Clear")
                .insertAfter(this.element)
                .click(e => {
                    this.set_value("");
                    this.element.triggerHandler("change");
                });
        }

        protected getFilterCriteria() {
            var filterField = this.filterField;
            var filterValue = this.filterValue;
            if (Q.isEmptyOrNull(filterField) ||
                filterValue == null || filterValue === '')
                return null;

            var crit = [[filterField], '=', filterValue];

            var parts = filterValue.toString().split(',').map(x => Q.trimToNull(x)).filter(x => x != null);
            if (parts.length > 0)
                crit = Serenity.Criteria.or(crit, [[filterField], 'in', [parts]]);

            return crit;
        }

        updateInterface() {
            this.element.toggleClass('readonly', !!this.readOnly);
            this.element.nextAll('.inplace-delete').toggle(!this.readOnly && !!this.get_value());
            this.element.nextAll('.inplace-edit').toggle(!this.readOnly);
        }

        get_value(): string {
            return this.value;
        }

        set_value(value: string): void {
            this.value = Q.coalesce(value, '');
            var values = this.value.split(',');
            if (values.length > 1)
                this.element.val(values.length + " targets selected");
            else if (!this.value || !this.value.length) {
                this.element.val(null);
            }
            else {
                var target = Q.tryFirst(ModelTargetRow.getLookup().items, x => x.TargetCode == this.value);
                if (target && target.Level) {
                    this.element.val(target['Code' + target.Level] + " - " + target['Name' + target.Level]);
                }
                else
                    this.element.val(this.value);
            }
            this.updateInterface();
        }

        get_readOnly(): boolean {
            return this.readOnly;
        }

        set_readOnly(value: boolean): void {
            if (this.readOnly != value) {
                this.readOnly = value;
                this.updateInterface();
            }
        }

        @Serenity.Decorators.option()
        filterField: string;

        @Serenity.Decorators.option()
        filterValue: string;
    }
}